
const digest = '0242a859065ba2e14c6ab8e02c809192fc42fb6a4d07590c4230407d173e8b08';
const classes = {"date":"_date_1nxpl_1","value":"_value_1nxpl_9"};
const css = `._date_1nxpl_1 {
  font-size: 10px;
  font-weight: 600;
  text-align: center;
  color: #99958c;
  margin: 0;
}

._value_1nxpl_9 {
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  margin: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  